import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { EntityRole } from '../../utils/apollo/graphqlSchema';
import { entityRolesLabels } from '../../utils/entityRoles';

interface IProps {
  entityRole: EntityRole;
}

const Container = styled.div`
  font-size: 10px;
  font-weight: 500;
  color: ${theme.colors.secondary800};
`;

const EntityRoleLabel = ({ entityRole }: IProps) => {
  return <Container>{entityRolesLabels[entityRole]} Access</Container>;
};

export default EntityRoleLabel;
